import React from 'react'
import { useNavigate } from 'react-router-dom'
import './PartnerLayout.css'

interface PartnerLayoutProps {
    children: React.ReactNode
    partner?: {
        companyName: string
        email: string
    }
}

const PartnerLayout: React.FC<PartnerLayoutProps> = ({ children, partner }) => {
    const navigate = useNavigate()

    const handleLogout = () => {
        // Clear session
        localStorage.removeItem('partnerToken')
        localStorage.removeItem('partner')

        // Redirect to login
        navigate('/')
    }

    return (
        <div className="partner-layout">
            <header className="partner-header">
                <div className="partner-header-content">
                    <div className="partner-header-left">
                        <h1 className="partner-logo">EmpreX API</h1>
                        <span className="partner-separator">|</span>
                        <span className="partner-subtitle">Documentation</span>
                    </div>

                    <div className="partner-header-right">
                        {partner && (
                            <div className="partner-info">
                                <div className="partner-avatar">
                                    {(partner.companyName || partner.email || '?').charAt(0).toUpperCase()}
                                </div>
                                <div className="partner-details">
                                    <div className="partner-company">{partner.companyName || 'Partner'}</div>
                                    <div className="partner-email">{partner.email}</div>
                                </div>
                            </div>
                        )}

                        <button
                            onClick={handleLogout}
                            className="logout-button"
                            title="Logout"
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </header>

            <main className="partner-main">
                {children}
            </main>

            <footer className="partner-footer">
                <p>© {new Date().getFullYear()} EmpreX. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default PartnerLayout
